module.exports = {
  pathPrefix: '/', // Prefix for all links. If you deploy your site to example.com/blog your pathPrefix should be "blog"
  siteTitle: 'Joe Fiorini', // Navigation and Site Title
  siteTitleAlt:
    'Blog about taming complex React apps and complexity in apps built with React.js, TypeScript & using React Hooks', // Alternative Site title for SEO
  siteTitleShort: 'Joe Fiorini', // short_name for manifest
  siteUrl: 'https://joefiorini.com', // Domain of your site. No trailing slash!
  siteLanguage: 'en', // Language Tag on <html> element
  siteLogo: 'images/logo.png', // Used for SEO and manifest, path to your image you placed in the 'static' folder
  siteDescription:
    'Tame complexity in your React app; simple posts with detailed examples describing how complexity creeps into React projects and how to solve it.',
  author: 'Joe Fiorini', // Author for schemaORGJSONLD
  organization: '',

  // siteFBAppID: '123456789', // Facebook App ID - Optional
  userTwitter: '@joegrammer2', // Twitter Username
  ogSiteName: 'Joe Fiorini', // Facebook Site Name
  ogLanguage: 'en_US',
  googleAnalyticsID: 'UA-58406625-2',

  // Manifest and Progress color
  themeColor: '#4297c3',
  backgroundColor: '#EEF4F2',

  // Social component
  twitter: 'https://twitter.com/joegrammer2/',
  twitterHandle: '@joegrammer2',
  github: 'https://github.com/joefiorini/',
  linkedin: 'https://linkedin.com/in/joefiorini',
  youtube: 'https://www.youtube.com/channel/UC8b1BsgHDWTb8W0HAJy9-Yw',
}
